// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#4484ce, #1ad7c0, #ff9b11, #9b59b6, #ff7f7f, #ecf0f1",
  firstName: "Anil",
  middleName: "",
  lastName: "Mathew",
  message: " Software Engineering | Programmer | Serverless Computing Enthusiast | Business Process Modeling ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/anil-rug",
    },
    {
      image: "fa-linkedin",
      url: "https://www.linkedin.com/in/anil-p-mathew/",
    },
  ],
};

// ABOUT SECTION
// If you want the About Section to show a profile picture you can fill the profilePictureLink either with:
//a) your Instagram username
//      i.e:profilePictureLink:"johnDoe123",
//b) a link to an hosted image
//      i.e:profilePictureLink:"www.picturesonline.com/johnDoeFancyAvatar.jpg",
//c) image in "editable-stuff" directory and use require("") to import here,
//      i.e: profilePictureLink: require("../editable-stuff/Anil_pic.png"),
//d) If you do not want any picture to be displayed, just leave it empty :)
//      i.e: profilePictureLink: "",
// For Resume either provide link to your resume or import from "editable-stuff" directory
//     i.e resume: require("../editable-stuff/resume.pdf"),
//         resume: "https://docs.google.com/document/d/13_PWdhThMr6roxb-UFiJj4YAFOj8e_bv3Vx9UHQdyBQ/edit?usp=sharing",

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/Anil_pic.png"),
  imageSize: 375,
  message:
    "My name is Anil Mathew. I’m a result-driven and dedicated IT expert seeking a full-time Software Architect or Engineering position to utilize logical thinking skills and programming expertise to provide the company with excellent software solutions.",
  resume: require("../editable-stuff/Anil Mathew Resume.pdf"),
};

// PROJECTS SECTION
// Setting up project lenght will automatically fetch your that number of recently updated projects, or you can set this field 0 to show none.
//      i.e: reposLength: 0,
// If you want to display specfic projects, add the repository names,
//      i.e ["repository-1", "repo-2"]
const repos = {
  show: true,
  heading: "Recent Projects",
  gitHubUsername: "anil-rug",
  reposLength: 4,
  specificRepos: [],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    { 
      img: require("../editable-stuff/Anil_pic.png"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
    { 
      img: require("../editable-stuff/Anil_pic.png"), 
      label: "Second slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    },
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "React", value: 80 },
    { name: "Angular", value: 70 },
    { name: "Nest JS", value: 85 },
    { name: "AWS/GCP/Azure", value: 75 },
    { name: "Python", value: 80 },
    { name: "SQL and NoSQL", value: 75 },
    { name: "TypeScript", value: 90 },
    { name: "HTML/CSS", value: 55 }
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 90 },
    { name: "Teamwork", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Communication", value: 80 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for full-time Software Architect or Engineering opportunities! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "anilpmm@gmail.com",
};

const experiences = {
  show: true,
  heading: "Experiences",
  data: [
    {
      role: 'Data Engineer - Part-time',// Here Add Company Name
      companylogo: require('../assets/img/researchable.png'),
      date: 'August 2020 – Present',
    },
    {
      role: 'Research Intern',
      companylogo: require('../assets/img/alumio.png'),
      date: 'May 2020 – July 2020',
    },
    {
      role: 'Software Engineer Team Lead',
      companylogo: require('../assets/img/accenture.png'),
      date: 'February 2017 – July 2019',
    },
    {
      role: 'Senior Software Engineer',
      companylogo: require('../assets/img/accenture.png'),
      date: 'December 2015 – January 2017',
    },
    {
      role: 'Software Engineer',
      companylogo: require('../assets/img/accenture.png'),
      date: 'July 2013 – November 2015',
    },
    {
      role: 'Associate Software Engineer',
      companylogo: require('../assets/img/accenture.png'),
      date: 'May 2012 – May 2013',
    },
    {
      role: 'Junior Business System Analyst',
      companylogo: require('../assets/img/aramco.png'),
      date: 'May 2011 – June 2011',
    },
  ]
}

const education = {
  show: true,
  heading: "Education",
  data: [
    {
      thesis: 'Implementing serverless data processing pipelines: A case study on cost and performance tradeoffs',// Here Add Company Name
      universitylogo: require('../assets/img/rug.png'),
      date: 'August 2019 – July 2021',
    },
    {
      thesis: 'A Tool for Software Design Decisions using Analytic Hierarchy Process (AHP) algorithm',
      universitylogo: require('../assets/img/amrita.png'),
      date: 'April 2008 – April 2012',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, repos, skills, leadership, getInTouch, experiences, education };
